import React from 'react';
import { motion } from 'framer-motion';
export function ScenarioSection() {
  return <section className="bg-cream text-navy py-24 px-5" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <div className="text-center mb-12" data-id="element-158">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-4" data-id="element-159">
            ¿Te suena familiar esto?
          </h2>
          <div className="w-12 h-1 bg-gold mx-auto" data-id="element-160"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy border border-gold/20 p-8 md:p-10 rounded-lg shadow-xl mb-10 relative" data-id="element-161">
          {/* Decorative quote mark */}
          <div className="absolute -top-6 -left-4 text-gold/20 font-playfair text-8xl leading-none select-none" data-id="element-162">
            "
          </div>

          <p className="font-dmsans text-lg md:text-xl text-cream/90 leading-relaxed relative z-10" data-id="element-163">
            Un cliente te contacta emocionado por un viaje. Pasás horas armando
            el itinerario perfecto, buscando las mejores opciones y ajustando
            detalles. Le mandás la{' '}
            <span className="text-gold font-medium" data-id="element-164">cotización</span> con toda
            la información detallada. Pasan los días... y el{' '}
            <span className="text-gold font-medium" data-id="element-165">cliente desaparece</span>.
            Ni un "gracias, lo voy a pensar". Silencio total.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-center max-w-2xl mx-auto" data-id="element-166">
          <p className="font-dmsans text-lg text-navy/80 leading-relaxed" data-id="element-167">
            El problema no es el cliente. Es la forma en que presentás tu
            propuesta. Sin estructura, sin{' '}
            <span className="text-gold font-bold" data-id="element-168">valor</span> percibido, sin
            seguimiento.
          </p>
        </motion.div>
      </div>
    </section>;
}